import React from "react";
import { MoneyApi } from "go-core/api/types";
import { ReactComponent as LongArrowDownSVG } from "../../../../../../../images/svg/documents/long-arrow-down.svg";
import { ReactComponent as LongArrowUpSVG } from "../../../../../../../images/svg/documents/long-arrow-up.svg";

interface Props {
	itemPrice?: MoneyApi;
	lastPrice?: MoneyApi;
}

const DocumentItemPriceDifferential = ({ lastPrice, itemPrice }: Props) => {
	if (!itemPrice || !lastPrice) return <></>;

	if (itemPrice.amount === lastPrice.amount) return <></>;

	const getCalculatedPercentValue = () => {
		if (!itemPrice.amount && lastPrice.amount) return -100;

		if (itemPrice.amount && !lastPrice.amount) return 100;

		return (itemPrice.amount / lastPrice.amount) * 100 - 100;
	};
	return (
		<div className="d-flex ms-2 document-item-price-differential align-items-center">
			{getCalculatedPercentValue() > 0 && <LongArrowUpSVG />}
			{getCalculatedPercentValue() < 0 && <LongArrowDownSVG />}
			<span className="ms-2">{`${getCalculatedPercentValue()}%`}</span>
		</div>
	);
};

export default DocumentItemPriceDifferential;
